



import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {GROW_TREE_MODAL_TYPE, GROW_TREE_TYPE} from "@/constants";
import {EventBusTreeModalType} from "@/share";
import {eventBusService} from "@/services";

@Component({})
export default class Step extends Vue {
  @Prop({type: Boolean, default: false}) isMilestone?: boolean
  @Prop({type: Boolean, default: false}) isActive?: boolean
  @Prop({type: Boolean, default: false}) isFocus?: boolean
  @Prop({type: Boolean, default: false}) isLast?: boolean
  @Prop({type: Number, default: GROW_TREE_TYPE.BODY}) type?: boolean
  @Prop(Number) id!: number

  private focus = false

  get imageClass(): any {
    let className = `category${this.type}`
    if (this.isMilestone) {
      if (this.isLast) {
        if (this.isActive) return className + ' is-milestone is-last is-active'
        return className + ' is-milestone is-last'
      }
      if (this.isActive) return className + ' is-milestone is-active'
      return className + ' is-milestone'
    }
    if (this.isActive) return className + ' is-step is-active'
    return className + ' is-step'
  }

  get classNameType(): string {
    if (this.isMilestone) {
      return 'is-milestone'
    }
    return 'is-step'
  }

  get imageSRC(): any {
    if (this.isMilestone) {
      if (this.isLast) {
        if (this.isActive) return require(`@/assets/images/category${this.type}/milestone-last-active.png`)
        return require('@/assets/images/milestone-last.png')
      }
      if (this.isActive) return require(`@/assets/images/category${this.type}/milestone-active.png`)
      return require('@/assets/images/milestone.png')
    }
    if (this.isActive) return require(`@/assets/images/category${this.type}/step-active.png`)
    return require('@/assets/images/step.png')
  }

  @Watch('isFocus', {immediate: true, deep: true})
  onIsFocusChange(isFocus: boolean) {
    if (!isFocus) this.focus = isFocus
  }

  get focusIconClass(): string {
    if (this.focus) return 'focus-icon'
    return ''
  }

  private onClickStep(e: any): void {
    this.focus = true
    let type = GROW_TREE_MODAL_TYPE.STEP
    if (this.isMilestone) type = GROW_TREE_MODAL_TYPE.MILESTONE

    const modalData = new EventBusTreeModalType({
      id: this.id,
      type: type,
      pageY: e.pageY,
      pageX: e.pageX,
    })

    eventBusService.$emit(eventBusService.EVENT_SHOW_TREE_MODAL, modalData)
  }
}
